export const GET_CATEGORIES = 'GET_CATEGORIES'
export const GET_CATEGORIES_SUCCESS = 'GET_CATEGORIES_SUCCESS'
export const GET_CATEGORIES_ERROR = 'GET_CATEGORIES_ERROR'

export const GET_THEMES_CATEGORIES = 'GET_THEMES_CATEGORIES'
export const GET_THEMES_CATEGORIES_SUCCESS = 'GET_THEMES_CATEGORIES_SUCCESS'
export const GET_THEMES_CATEGORIES_ERROR = 'GET_THEMES_CATEGORIES_ERROR'

export const GET_CATEGORY = 'GET_CATEGORY'
export const GET_CATEGORY_SUCCESS = 'GET_CATEGORY_SUCCESS'
export const GET_CATEGORY_ERROR = 'GET_CATEGORY_ERROR'

export const GET_PARENT_CATEGORY = 'GET_PARENT_CATEGORY'
export const GET_PARENT_CATEGORY_SUCCESS = 'GET_PARENT_CATEGORY_SUCCESS'
export const GET_PARENT_CATEGORY_ERROR = 'GET_PARENT_CATEGORY_ERROR'
